module.exports = __webpack_public_path__ + "assets/img/K7.bc4fec15.png";